import React from "react";
import Sidebar from "./Sidebar";

/** Alternatif sidebar shell — Tema 2 (stil/logic burada veya Sidebar içinde shellThemeVariant ile genişletilir) */
const SidebarTheme2 = (props) => <Sidebar {...props} shellThemeVariant="2" />;

export default SidebarTheme2;
